export const getQueryString = (queryParams) => {
  const params = Object.entries(queryParams)
    .filter(([key, value]) => value)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  return params ? `?${params}` : '';
};
